module.exports = "/_next/static/images/00b7d4844b75f87bc7276fa4d38fb21a-lock.svg";